import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

// Inside your HomePage component
const HomePageRedirect = ({ siteLanguage }) => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`/${siteLanguage}`);
  }, [siteLanguage, navigate]);

  // rest of your component code...
};

export default HomePageRedirect;
